import api from '../api';

export const PostBuscaTermoDeAdesao = async ({ token, CD_AGENDAMENTO }: { token: string, CD_AGENDAMENTO: number }) => {
    try {
        const { data } = await api.post(`/v1/Plataforma/BuscaTermoDeAdesao/${CD_AGENDAMENTO}`, {}, {
            responseType: 'blob',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        if (data) {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');

            link.href = url
            link.setAttribute('download', 'myFile.pdf')
            document.body.appendChild(link)
            link.click()
        }
        return { data: true };
    } catch (error) {
        return { data: false };
    }
}
